export default __webpack_public_path__ + "static/media/menu.57362152.svg";